import { render, staticRenderFns } from "./print-table-renwu.vue?vue&type=template&id=1fae4fa1&scoped=true"
import script from "./print-table-renwu.vue?vue&type=script&lang=js"
export * from "./print-table-renwu.vue?vue&type=script&lang=js"
import style0 from "./print-table-renwu.vue?vue&type=style&index=0&id=1fae4fa1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fae4fa1",
  null
  
)

export default component.exports